import { render, staticRenderFns } from "./ResepObat.vue?vue&type=template&id=e1219e40&"
import script from "./ResepObat.vue?vue&type=script&lang=js&"
export * from "./ResepObat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports